module.exports = __webpack_public_path__ + "img/20i.b56654b9.png";